import { Typography } from "@mui/material";
import type { SvgIconProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HTMLAttributes, ReactNode } from "react";

export type LabeledSectionProps = {
    title: ReactNode;
    Icon?: React.ComponentType<SvgIconProps>;
} & HTMLAttributes<HTMLElement>;

export const Wrapper = styled("section")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
}));

export const HeaderWrapper = styled("header")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1.5),
    alignItems: "center",
}));

export const IconWrapper = styled("div")({
    flexGrow: 0,
    flexShrink: 0,
    display: "inline-flex",
});

export const Title = styled(Typography)({
    "&": {
        fontSize: 28,
        flexGrow: 100,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "calc(100% - 50px)",
    },
});

export function LabeledSection({ Icon, title, children, ...props }: LabeledSectionProps) {
    return (
        <Wrapper {...props}>
            <HeaderWrapper>
                {Icon && (
                    <IconWrapper>
                        <Icon color="primary" fontSize="large" />
                    </IconWrapper>
                )}
                <Title>{title}</Title>
            </HeaderWrapper>
            <div>{children}</div>
        </Wrapper>
    );
}
